import { render, staticRenderFns } from "./UploadModule.vue?vue&type=template&id=413c7970&scoped=true&"
import script from "./UploadModule.vue?vue&type=script&lang=js&"
export * from "./UploadModule.vue?vue&type=script&lang=js&"
import style0 from "./UploadModule.vue?vue&type=style&index=0&id=413c7970&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c7970",
  null
  
)

export default component.exports